import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '@thd-olt-component-react/input';
import { emailValidator } from '../../common/sharedFunctions';
import constants from '../../constants/constants';

export function EmailFieldFormatter({ name, value, callback }) {
  return (
    <Input
      name={`email-${name}`}
      data-testid="email-input"
      header="Email Address"
      defaultValue=""
      errorText={constants.EMAIL_FIELD_VALIDATOR_ERROR_TEXT}
      value={value}
      validation={emailValidator}
      onChange={callback}
      validateOnBlur
    />
  );
}

EmailFieldFormatter.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
};

EmailFieldFormatter.defaultProps = {
  name: 'email-input'
};

export const formatEmail = (val) => {
  if (!val) {
    return '';
  }
  return val.trim().toLowerCase();

};
